import { render, staticRenderFns } from "./Activtiy.vue?vue&type=template&id=2b4a5ce9&scoped=true"
import script from "./Activtiy.vue?vue&type=script&lang=js"
export * from "./Activtiy.vue?vue&type=script&lang=js"
import style0 from "./Activtiy.vue?vue&type=style&index=0&id=2b4a5ce9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a5ce9",
  null
  
)

export default component.exports